import axios, { AxiosResponse } from 'axios';
import IUserList from '../UserList/UserList.interface';
import { adminUserList } from './OrganizationUser.helper';
import IOrganizationUser from './OrganizationUser.interface';
import { invalidateSession } from '../../store/slice/sessionSlice';
import { store } from '../../store/store';
import { decrypt } from '../Helper/encryption';

// Declaring the web server path
const backEndServerUrl = String(process.env.REACT_APP_BACK_END_SERVER_URL ?? '');
export default class OrganizationAdmin {
  // Storing the user's email via session storage
  public userEmail = sessionStorage.getItem('userEmail');

  // Declaring the sub-path
  public subPath: string = `/organization/admin/${this.userEmail}`;
  public encryptedToken = sessionStorage.getItem('jwtToken');
  public jwtToken = decrypt(this.encryptedToken);
  public apiKey = String(process.env.REACT_APP_API_KEY ?? '');
  // creating header to wrap during the api call.
  public config = {
    headers: {
      Authorization: this.jwtToken,
      'x-api-key': this.apiKey
    }
  };

  // GET request for fetching data from db to Organization User. This method is an array of type IUserList or null
  public async getAllAdminUser(): Promise<{
    fullName: string;
    users: Array<IUserList | null>;
    admin: IUserList | null;
  }> {
    try {
      const url: string = this.createUrl(this.subPath);
      const response: AxiosResponse<any, any> = await axios.get(url, this.config);
      const { orgAdmin } = response.data;
      if (!orgAdmin.email && !orgAdmin.partnerCompanyName) {
        store.dispatch(invalidateSession());
      }
      const extractedFname = orgAdmin?.fname || '';
      const extractedLname = orgAdmin?.lname || '';
      const fullName = extractedFname + ' ' + extractedLname;
      sessionStorage.setItem('adminFullName', fullName);
      sessionStorage.setItem('adminFirstName', extractedFname);
      const companyName = orgAdmin?.partnerCompanyName || '';
      sessionStorage.setItem('companyName', companyName);
      sessionStorage.setItem('domainList', JSON.stringify(orgAdmin?.domains));
      const arrAdmin: Array<IOrganizationUser | null> = [];
      response.data.orgUser.forEach((element: IOrganizationUser) => {
        arrAdmin.push(element);
      });
      return {
        fullName,
        users: adminUserList(arrAdmin),
        admin: orgAdmin
      };
    } catch (error: any) {
      console.error(error);
      if (error.code === 'ERR_NETWORK') {
        store.dispatch(invalidateSession());
        return {
          fullName: '',
          users: [],
          admin: null
        };
      }
    }
    return await this.getAllAdminUser();
  }

  public async getAllAdminUserModule(): Promise<Array<IUserList | null>> {
    try {
      const url: string = this.createUrl(this.subPath);
      const response: AxiosResponse<any, any> = await axios.get(url, this.config);
      if (!response.data.orgAdmin.email && !response.data.orgAdmin.partnerCompanyName) {
        store.dispatch(invalidateSession());
      }
      const arrAdmin: Array<IOrganizationUser | null> = [];

      // Store orgAdmin data in the array
      arrAdmin.push(response.data.orgAdmin);

      // Store orgUser data in the array
      response.data.orgUser.forEach((element: IOrganizationUser) => {
        arrAdmin.push(element);
      });

      return adminUserList(arrAdmin);
    } catch (error: any) {
      console.error(error);
      if (error.code === 'ERR_NETWORK') {
        store.dispatch(invalidateSession());
        return [];
      }
    }
    return await this.getAllAdminUserModule();
  }

  // Binding the Webserver path and sub-path

  private createUrl(params?: string): string {
    return backEndServerUrl + params;
  }
}
